module.exports = __webpack_public_path__ + "img/KP.b89e20ee.svg";